import React, { useState } from "react";

import { Table, Pagination } from "../../../components/shared";

import { AddIcon, FilterIcon, FilterIconWhite } from "../../../assets";
import useSearchAndFilter from "../../../hooks/useSearchAndFilter";
import { Loader } from "../../../components/loaders/loaders";
import AddVehicleType from "../../../components/modals/systemConfigurationModal/AddVehicleType";
import FilterSideMenu from "../../../components/shared/FilterSideMenu";
import { Badge } from "@mui/material";
import { DEFAULT_PAGE_SIZE } from "../../../utils/constants";
import { SERVICE_CONFIG_MESSAGES } from "../../../utils/message";

interface OrderStatusResponse {
  id: string;
  count: number | string;
  active: boolean;
  orderStatus: {
    id: string;
    name: string;
    isActive: boolean;
  };
  dispatchTrackOrderStatus: string;
}

const columns = [
  { key: "count", header: "S.", isSortable: false, className: "count" },
  {
    key: "name",
    header: "Vehicle Type",
    isSortable: true,
    className: "dark",
  },
  {
    key: "description",
    header: "Description",
    isSortable: true,
    className: "dark",
  },
  {
    key: "active",
    header: "Active",
    isSortable: false,
    isActive: true,
    handleActive: true,
    className: "dark",
  },
];

const mapUserData = (data: any) =>
  data.map((item: any) => ({
    id: item?.id,
    count: item?.count,
    name: item?.name || "",
    description: item?.description || "",
    active: item?.isActive || false,
  }));

const tableConfig = {
  delete: {
    apiUrl: "/service/vehicletype/delete/",
    urlID: "id",
    successMessage: SERVICE_CONFIG_MESSAGES.VEHICLE_TYPE_DELETE_SUCCESS,
    heading: SERVICE_CONFIG_MESSAGES.VEHICLE_TYPE_DELETE_HEADING,
    para: "delete",
    rowName: "name",
    secondRowName: "",
    deleteByPutApi: true,
  },
};

interface AgentApiOrderStatusProps {
  apiData?: {
    agentId: string;
    agentHubId: string;
    orderDispatchCredId: string;
  };
  apiType?: {
    id: string;
    name: string;
  };
}

const VehicleType: React.FC<AgentApiOrderStatusProps> = ({
  apiData,
  apiType,
}) => {
  const locationData = {
    id: "12345",
  };
  /**
   * Custom hook for fetching data, handling search, and managing pagination.
   *
   * @param apiUrl - The URL to fetch data from.
   * @param limit - The maximum number of items to fetch.
   * @param mapUserData - Function to map the fetched data.
   *
   * @returns data - The fetched data for display in the table.
   * @returns keyword - The current search keyword.
   * @returns loading - Boolean indicating if data is being loaded.
   * @returns setLoading - Function to set the loading state.
   * @returns handleKeywordChange - Function to handle changes in the search input and debounce API calls.
   * @returns fetchFilteredData - Function to fetch data based on the current filters.
   * @returns setData - Function to set the data.
   */
  const {
    data,
    loading,
    setLoading,
    fetchFilteredData,
    fetchWithCurrentFilters,
    closeOpenfilterModal,
    isShowFilterModal,
    selectStatus,
    setSelectStatus,
    vehicleType,
    setVehicleType,
    filterApplied,
    setFilterApplied,
    captureAppliedFilters,
    clearCurrentFilters,
  } = useSearchAndFilter<OrderStatusResponse>({
    apiUrl: "/service/vehicletype",
    limit: DEFAULT_PAGE_SIZE,
    mapUserData,
    screenKey: "vehicleType",
  });
  const [isShowModal, setIsShowModal] = useState<boolean>(false);
  const [modalType, setModalType] = useState<string>("Add");
  const [rowData, setRowData] = useState();

  const handleEditModal = (data: any) => {
    setModalType("Edit");
    setIsShowModal(true);
    setRowData(data);
  };

  return (
    <>
      <div
        className={`tableWrap ${
          isShowFilterModal ? "tableWrap--filterOpen" : ""
        }`}
      >
        <div className="tableWrap__head tableWrap__head--end">
          <div className="btn__group">
            {filterApplied ? (
              <Badge badgeContent=" " color="primary">
                <button
                  className={
                    !isShowFilterModal ? "btn btn__white" : "btn btn__primary"
                  }
                  onClick={closeOpenfilterModal}
                >
                  {!isShowFilterModal ? <FilterIcon /> : <FilterIconWhite />}
                  Filter
                </button>
              </Badge>
            ) : (
              <button
                className={
                  !isShowFilterModal ? "btn btn__white" : "btn btn__primary"
                }
                onClick={() => {
                  // setShowEditColumn(false);
                  closeOpenfilterModal();
                }}
              >
                {!isShowFilterModal ? <FilterIcon /> : <FilterIconWhite />}
                Filter
              </button>
            )}
            <FilterSideMenu
              isShowFilterModal={isShowFilterModal}
              closeOpenfilterModal={closeOpenfilterModal}
              selectStatus={selectStatus}
              setSelectStatus={setSelectStatus}
              isStatusHide={false}
              isRoleHide={true}
              isOrderStatusHide={true}
              isOrderTypeHide={true}
              isAgentTypeHide={true}
              isHubHide={true}
              isServiceHide={true}
              isCustomerTypeHide={false}
              isAllCustomerTypeHide={true}
              showVehicleType={true}
              vehicleType={vehicleType}
              setVehicleType={setVehicleType}
              fetchFilteredData={fetchFilteredData}
              onFiltersApplied={captureAppliedFilters}
              filterApplied={filterApplied}
              setFilterApplied={setFilterApplied}
              table="vehicleType"
              clearFiltersFromStorage={clearCurrentFilters}
            />
            <button
              className="btn btn__white w_fitContent"
              onClick={() => {
                setModalType("Add");
                setIsShowModal(true);
              }}
            >
              <AddIcon />
              Create New
            </button>
          </div>
        </div>
        <Table
          columns={columns}
          data={data}
          setLoading={setLoading}
          onDeleteConfig={tableConfig.delete}
          editModalHanlde={handleEditModal}
          getApiData={fetchWithCurrentFilters}
          disabledActive={true}
          deleteIcon={true}
          activeIcon={true}
          editIcon={true}
        />
        <Pagination />
      </div>
      {isShowModal && (
        <AddVehicleType
          confirmModal={isShowModal}
          setConfirmModal={setIsShowModal}
          rowData={rowData}
          modalType={modalType}
          setLoading={setLoading}
          xceleratorId={locationData?.id}
          getApiData={fetchWithCurrentFilters}
          apiData={apiData}
          apiType={apiType}
        />
      )}
      {loading && <Loader />}
    </>
  );
};

export default VehicleType;
